import { customerConstants } from "@_constants/customer.constants";
import { customerService } from "@_services/customer.service";
import { handleError } from "@_utils/helpers";

export const customerActions = {
  clearStatusMessage,
  sendVerficationEmail,
  verifiedCustomer,
  getPaymentReport,
  getPaymentReportDetails,
  getCasesReport,
  getCaseTags,
  getCredits,
  addCredits,
};

function clearStatusMessage(stateName) {
  return (dispatch) => {
    dispatch(clear(stateName));
  };

  function clear(stateName) {
    return { type: customerConstants.CUSTOMER_CLEAR_STATUS_MESSAGE, stateName };
  }
}

function sendVerficationEmail(data) {
  return (dispatch) => {
    dispatch(request(data));
    customerService.sendVerficationEmail(data).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      }
    );
  };

  function request() {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_EMAIL_REQUEST,
      data,
    };
  }
  function success(data) {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_EMAIL_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_EMAIL_FAILURE,
      error,
    };
  }
}

function verifiedCustomer(id) {
  return (dispatch) => {
    dispatch(request(id));
    customerService.verifiedCustomer(id).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      }
    );
  };

  function request() {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_REQUEST,
      id,
    };
  }
  function success(data) {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_FAILURE,
      error,
    };
  }
}

function getPaymentReport(startDate, endDate) {
  return (dispatch) => {
    dispatch(request(startDate, endDate));
    customerService.getPaymentReport(startDate, endDate).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      }
    );
  };

  function request() {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_REQUEST,

      startDate,
      endDate,
    };
  }
  function success(data) {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_FAILURE,
      error,
    };
  }
}

function getPaymentReportDetails(startDate, endDate) {
  return (dispatch) => {
    dispatch(request(startDate, endDate));
    customerService.getPaymentReportDetails(startDate, endDate).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      }
    );
  };

  function request() {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_REQUEST,
      startDate,
      endDate,
    };
  }
  function success(data) {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: customerConstants.CUSTOMER_VERIFICATION_PUT_FAILURE,
      error,
    };
  }
}

function getCasesReport(data) {
  return (dispatch) => {
    dispatch(request(data));
    customerService.getCasesReport(data).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      }
    );
  };
  function request() {
    return {
      type: customerConstants.CUSTOMER_GET_CASES_REPORT_REQUEST,
    };
  }
  function success(data) {
    return {
      type: customerConstants.CUSTOMER_GET_CASES_REPORT_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: customerConstants.CUSTOMER_GET_CASES_REPORT_FAILURE,
      error,
    };
  }
}

function getCaseTags() {
  return (dispatch) => {
    dispatch(request());
    customerService.getCaseTags().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      }
    );
  };

  function request() {
    return {
      type: customerConstants.CUSTOMER_GET_CASE_TAG_REQUEST,
    };
  }
  function success(data) {
    return {
      type: customerConstants.CUSTOMER_GET_CASE_TAG_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: customerConstants.CUSTOMER_GET_CASE_TAG_FAILURE,
      error,
    };
  }
}

function getCredits() {
  return (dispatch) => {
    dispatch(request());
    customerService.getCredits().then(
      (data) => {
        dispatch(success(data.amount));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      }
    );
  };

  function request() {
    return {
      type: customerConstants.CUSTOMER_GET_CREDITS_REQUEST,
    };
  }
  function success(data) {
    return {
      type: customerConstants.CUSTOMER_GET_CREDITS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: customerConstants.CUSTOMER_GET_CREDITS_FAILURE,
      error,
    };
  }
}

function addCredits(creditData) {
  return (dispatch) => {
    dispatch(request());
    customerService.addCredits(creditData).then(
      (data) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(handleError(error)));
      }
    );
  };

  function request() {
    return {
      type: customerConstants.CUSTOMER_ADD_CREDITS_REQUEST,
    };
  }
  function success(data) {
    return {
      type: customerConstants.CUSTOMER_ADD_CREDITS_SUCCESS,
    };
  }
  function failure(error) {
    return {
      type: customerConstants.CUSTOMER_ADD_CREDITS_FAILURE,
      error,
    };
  }
}
